import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlangridComponent } from './simple-icons-plangrid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlangridComponent ],
    exports:      [ SimpleIconsPlangridComponent ],
    bootstrap:    []
})
export class SimpleIconsPlangridModule {}
